<div
  *ngIf="selectedPlanData$ | async as planData"
  [@floatingMenu]="isVisible ? 'visible' : 'hidden'"
  class="container"
  [ngClass]="{ 'menu-group-view': menuGroupData.isOpened }"
>
  <ul *ngIf="!menuGroupData.isOpened" class="menu-items-list">
    <ng-container *ngIf="!!planData.registration">
      <li class="menu-item">
        <button
          mat-raised-button
          (click)="
            openMenuGroup(menuGroupsEnum.MANAGE_PLANS, planData.menuFeatList)
          "
        >
          {{ menuItemTitleEnum.MANAGE_PLANS }}
          <mat-icon svgIcon="chevron-right" iconPositionEnd></mat-icon>
        </button>
      </li>
      <div class="divider"></div>
    </ng-container>
    <ng-container
      *ngIf="
        planData.registration &&
        hasFeatOn(feature.EXTRA_CONTRIBUTION, planData.cardsFeatList)
      "
    >
      <li class="menu-item">
        <button
          mat-raised-button
          (click)="
            handleNavigationItemAction(
              feature.EXTRA_CONTRIBUTION,
              planData.registration
            )
          "
        >
          {{ menuItemTitleEnum.EXTRA_CONTRIBUTION }}
        </button>
      </li>
      <div class="divider"></div>
    </ng-container>
    <ng-container *ngIf="!!planData?.menuFeatList?.length">
      <li class="menu-item">
        <button
          (click)="
            openMenuGroup(menuGroupsEnum.OTHER_FEATURES, planData.menuFeatList)
          "
          mat-raised-button
        >
          {{ menuItemTitleEnum.OTHER_FEATURES }}
          <mat-icon svgIcon="chevron-right" iconPositionEnd></mat-icon>
        </button>
      </li>
      <div class="divider"></div>
    </ng-container>
    <li class="menu-item" (click)="navigateTo('/support')">
      <button mat-raised-button>
        {{ menuItemTitleEnum.SUPPORT }}
      </button>
    </li>
    <ng-container *ngIf="!isSinglePlan">
      <div class="divider"></div>
      <li class="menu-item" (click)="navigateTo('/')">
        <button mat-raised-button>
          {{ menuItemTitleEnum.LIST_PLANS }}
        </button>
      </li>
    </ng-container>
  </ul>

  <ul *ngIf="menuGroupData.isOpened" class="menu-items-list">
    <li class="menu-item close-menu-group-item">
      <button mat-raised-button (click)="closeMenuGroup()">
        {{ menuGroupData.title }}
        <mat-icon svgIcon="chevron-right" iconPositionEnd></mat-icon>
      </button>
    </li>
    <div class="divider transparent"></div>
    @for (
      feature of menuGroupData.features;
      track $index;
      let lastItem = $last
    ) {
      <li class="menu-item menu-group-item">
        <button
          mat-raised-button
          (click)="handleNavigationItemAction(feature, planData.registration)"
        >
          {{ featTitle[feature] }}
        </button>
      </li>
      <div *ngIf="!lastItem" class="divider"></div>
    }
  </ul>
</div>
